function n(o) {
  const r = (o || "").split("/").map((t) => t.trim()).filter((t) => t !== "");
  return r[0] !== "root" && r.unshift("root"), r.map((t) => `realms/${t}`).join("/");
}
export {
  n as getRealmUrlPath
};
